import { useEffect } from 'react';

/**
 * 06-qol §4: "unsaved changes warning when navigating away from a dirty form" — for
 * the admin editors, which save on a button rather than as they go.
 */
export function useUnsavedWarning(isDirty: boolean): void {
  useEffect(() => {
    if (!isDirty) return undefined;
    const warn = (event: BeforeUnloadEvent): void => event.preventDefault();
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [isDirty]);
}
